import {
  handleWithErrorMessage,
  handleWithGlobalMessage,
  errorHandler
} from "@/services/utils";
import {
  SET_OFFERS,
  SET_IS_FETCHING_OFFERS,
  SET_CURRENT_OFFER,
  SET_IS_FETCHING_CURRENT_CONTRACT,
  SET_CURRENT_CONTRACT,
  SET_IS_FETCHING_CURRENT_OFFER,
  SET_IS_LOADING_OFFER_COMMENTS,
  SET_OFFER_COMMENTS,
  SET_IS_LOADING_OFFER_GROUP_DOCUMENT,
  SET_OFFER_GROUP_DOCUMENT,
  SET_IS_ADDING_FILE_TO_OFFER_GROUP,
  SET_IS_FETCHING_CURRENT_OFFER_GROUPS,
  SET_CURRENT_OFFER_GROUPS,
  SET_OFFER_GROUP_TEMPLATES,
  SET_IS_LOADING_OFFER_GROUP_TEMPLATES,
  SET_IS_ADDING_OFFER_GROUP,
  SET_IS_FETCHING_OFFER_DOCUMENT_COMMENTS,
  SET_OFFER_DOCUMENT_COMMENTS
} from "@/store/modules/offers/mutations";
import api from "@/services/modules/offers";
import dataApi from "@/services/modules/data";

export const FETCH_OFFERS = "FETCH_OFFERS";
export const FETCH_CURRENT_OFFER = "FETCH_CURRENT_OFFER";
export const MARK_OFFER_STEP_COMPLETE = "MARK_OFFER_STEP_COMPLETE";
export const CREATE_OFFER = "CREATE_OFFER";
export const UPDATE_OFFER = "UPDATE_OFFER";
export const WITHDRAW_OFFER = "WITHDRAW_OFFER";
export const REJECT_OFFER = "REJECT_OFFER";
export const ACCEPT_OFFER = "ACCEPT_OFFER";
export const APPROVE_DOCUMENT = "APPROVE_DOCUMENT";
export const SUBMIT_DOCUMENT_FOR_APPROVAL = "SUBMIT_DOCUMENT_FOR_APPROVAL";
export const REJECT_DOCUMENT = "REJECT_DOCUMENT";
export const COMPLETE_OFFER = "COMPLETE_OFFER";
export const REQUEST_OFFER_REFERENCES = "REQUEST_OFFER_REFERENCES";
export const APPROVE_OFFER = "APPROVE_OFFER";
export const SUBMIT_OFFER_FOR_APPROVAL = "SUBMIT_OFFER_FOR_APPROVAL";
export const FETCH_OFFER_COMMENTS = "FETCH_OFFER_COMMENTS";
export const ADD_OFFER_COMMENT = "ADD_OFFER_COMMENT";
export const ADD_OFFER_DOCUMENT_COMMENT = "ADD_OFFER_DOCUMENT_COMMENT";
export const FETCH_OFFER_MAILTO = "FETCH_OFFER_MAILTO";
export const FETCH_OFFER_GROUP_DOCUMENT = "FETCH_OFFER_GROUP_DOCUMENT";
export const FETCH_OFFER_DOCUMENT_COMMENTS = "FETCH_OFFER_DOCUMENT_COMMENTS";
export const ADD_FILE_TO_OFFER_GROUP = "ADD_FILE_TO_OFFER_GROUP";
export const ADD_CONTRACT_TO_OFFER = "ADD_CONTRACT_TO_OFFER";
export const REQUEST_SIGN_OFFER_CONTRACT = "REQUEST_SIGN_OFFER_CONTRACT";
export const SIGN_OFFER_CONTRACT = "SIGN_OFFER_CONTRACT";
export const FETCH_CURRENT_OFFER_GROUPS = "FETCH_CURRENT_OFFER_GROUPS";
export const FETCH_OFFER_GROUP_TEMPLATES = "FETCH_OFFER_GROUP_TEMPLATES";
export const ADD_OFFER_GROUP = "ADD_OFFER_GROUP";
export const REMOVE_OFFER_GROUP = "REMOVE_OFFER_GROUP";
export const EDIT_OFFER_GROUP = "EDIT_OFFER_GROUP";
export const FETCH_CURRENT_CONTRACT = "FETCH_CURRENT_CONTRACT";

const actions = {
  async [FETCH_OFFERS]({ commit, dispatch }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getOffers(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_OFFERS, isLoading),
      setDataFunction: ({ data }) => commit(SET_OFFERS, data)
    });
  },
  async [FETCH_CURRENT_OFFER]({ dispatch, commit }, id) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getOffer(id),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_CURRENT_OFFER, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_OFFER, data)
    });
  },
  async [FETCH_CURRENT_CONTRACT]({ dispatch, commit }, id) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getContract(id),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_CURRENT_CONTRACT, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_CONTRACT, data)
    });
  },
  async [FETCH_CURRENT_OFFER_GROUPS]({ dispatch, commit }, id) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getOfferGroups(id),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_CURRENT_OFFER_GROUPS, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_OFFER_GROUPS, data)
    });
  },
  async [SUBMIT_OFFER_FOR_APPROVAL]({ dispatch, commit }, offerId) {
    await handleWithGlobalMessage(
      () => api(commit).submitOfferForApproval(offerId),
      dispatch
    );
    dispatch(FETCH_CURRENT_OFFER, offerId);
  },
  async [APPROVE_OFFER]({ dispatch, commit }, offerId) {
    await handleWithGlobalMessage(
      () => api(commit).approveOffer(offerId),
      dispatch
    );
    dispatch(FETCH_CURRENT_OFFER, offerId);
  },
  async [MARK_OFFER_STEP_COMPLETE]({ dispatch, commit }, stepId) {
    await handleWithGlobalMessage(
      () => api(commit).markOfferStepComplete(stepId),
      dispatch
    );
  },
  async [CREATE_OFFER]({ dispatch, commit }, data) {
    return await handleWithGlobalMessage(
      () => api(commit).createOffer(data),
      dispatch
    );
  },
  async [UPDATE_OFFER]({ dispatch, commit }, data) {
    try {
      const { data: updatedOffer } = await api(commit).updateOffer(data);
      commit(SET_CURRENT_OFFER, updatedOffer);
    } catch (e) {
      errorHandler(dispatch, e);
    }
  },
  async [WITHDRAW_OFFER]({ dispatch, commit }, offerId) {
    await handleWithGlobalMessage(
      () => api(commit).withdrawOffer(offerId),
      dispatch
    );
    dispatch(FETCH_CURRENT_OFFER, offerId);
  },
  async [REJECT_OFFER]({ dispatch, commit }, offerId) {
    await handleWithGlobalMessage(
      () => api(commit).rejectOffer(offerId),
      dispatch
    );
    dispatch(FETCH_CURRENT_OFFER, offerId);
  },
  async [ACCEPT_OFFER]({ dispatch, commit }, offerId) {
    await handleWithGlobalMessage(
      () => api(commit).acceptOffer(offerId),
      dispatch
    );
    dispatch(FETCH_CURRENT_OFFER, offerId);
  },
  async [APPROVE_DOCUMENT]({ dispatch, commit }, { offerId, documentId }) {
    await handleWithGlobalMessage(
      () => api(commit).approveDocument(offerId, documentId),
      dispatch
    );
    dispatch(FETCH_OFFER_GROUP_DOCUMENT, { offerId, documentId });
  },
  async [SUBMIT_DOCUMENT_FOR_APPROVAL](
    { dispatch, commit },
    { offerId, documentId, data }
  ) {
    await handleWithGlobalMessage(
      () =>
        api(commit).submitDocumentForApproval({ offerId, documentId, data }),
      dispatch
    );
    dispatch(FETCH_OFFER_GROUP_DOCUMENT, { offerId, documentId });
  },
  async [FETCH_OFFER_DOCUMENT_COMMENTS](
    { dispatch, commit },
    { offerId, documentId }
  ) {
    return handleWithErrorMessage({
      dispatch,
      request: () =>
        api({ commit }).getOfferDocumentComments(offerId, documentId),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_OFFER_DOCUMENT_COMMENTS, isLoading),
      setDataFunction: ({ data }) => commit(SET_OFFER_DOCUMENT_COMMENTS, data)
    });
  },
  async [REJECT_DOCUMENT]({ dispatch, commit }, { offerId, documentId }) {
    await handleWithGlobalMessage(
      () => api(commit).rejectDocument(offerId, documentId),
      dispatch
    );
    dispatch(FETCH_OFFER_GROUP_DOCUMENT, { offerId, documentId });
  },
  async [COMPLETE_OFFER]({ dispatch, commit }, offerId) {
    await handleWithGlobalMessage(
      () => api(commit).completeOffer(offerId),
      dispatch
    );
    dispatch(FETCH_CURRENT_OFFER, offerId);
  },
  async [REQUEST_OFFER_REFERENCES]({ dispatch, commit }, offerId) {
    return handleWithGlobalMessage(
      () => api(commit).requestOfferReferences(offerId),
      dispatch
    );
  },
  async [FETCH_OFFER_COMMENTS]({ dispatch, commit }, id) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getOfferComments(id),
      setLoadingFunction: isLoading =>
        commit(SET_IS_LOADING_OFFER_COMMENTS, isLoading),
      setDataFunction: ({ data }) => {
        commit(SET_OFFER_COMMENTS, data);
      }
    });
  },
  async [ADD_OFFER_COMMENT]({ dispatch, commit, state }, data) {
    const { data: newComment } = await handleWithErrorMessage({
      dispatch,
      request: () => dataApi(commit).addComment(data)
    });
    const newComments = [...state.offerComments, newComment];
    commit(SET_OFFER_COMMENTS, newComments);
  },
  async [ADD_OFFER_DOCUMENT_COMMENT]({ dispatch, commit, state }, data) {
    const { data: newComment } = await handleWithErrorMessage({
      dispatch,
      request: () => dataApi(commit).addComment(data)
    });
    const newComments = [...state.offerGroupDocumentComments, newComment];
    commit(SET_OFFER_DOCUMENT_COMMENTS, newComments);
  },
  async [ADD_FILE_TO_OFFER_GROUP](
    { dispatch, commit },
    { offerGroupId, offerId, data }
  ) {
    await handleWithErrorMessage({
      dispatch,
      request: () =>
        api(commit).addFileToOfferGroup({ offerGroupId, offerId, data }),
      setLoadingFunction: isLoading =>
        commit(SET_IS_ADDING_FILE_TO_OFFER_GROUP, isLoading)
    });
    dispatch(FETCH_CURRENT_OFFER_GROUPS, offerId);
  },
  async [ADD_CONTRACT_TO_OFFER]({ dispatch, commit }, { offerId, data }) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).addContractToOffer({ offerId, data })
    });
  },
  async [REQUEST_SIGN_OFFER_CONTRACT]({ dispatch, commit }, id) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).requestSignOfferContract(id)
    });
  },
  async [SIGN_OFFER_CONTRACT]({ dispatch, commit }, id) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).signOfferContract(id)
    });
  },
  async [FETCH_OFFER_MAILTO]({ dispatch, commit }, id) {
    try {
      const { uri } = await api(commit).getOfferMailto(id);
      return uri;
    } catch (exception) {
      errorHandler(dispatch, exception);
    }
  },
  async [FETCH_OFFER_GROUP_DOCUMENT](
    { dispatch, commit },
    { offerId, documentId }
  ) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getOfferGroupDocument({ offerId, documentId }),
      setLoadingFunction: isLoading =>
        commit(SET_IS_LOADING_OFFER_GROUP_DOCUMENT, isLoading),
      setDataFunction: ({ data }) => {
        commit(SET_OFFER_GROUP_DOCUMENT, data);
      }
    });
  },
  async [FETCH_OFFER_GROUP_TEMPLATES]({ dispatch, commit }) {
    return handleWithErrorMessage({
      dispatch,
      request: api(commit).getOfferGroupTemplates,
      setLoadingFunction: isLoading =>
        commit(SET_IS_LOADING_OFFER_GROUP_TEMPLATES, isLoading),
      setDataFunction: ({ data }) => {
        commit(SET_OFFER_GROUP_TEMPLATES, data);
      }
    });
  },
  async [ADD_OFFER_GROUP]({ dispatch, commit }, { offerId, templateId }) {
    await handleWithErrorMessage({
      dispatch,
      request: () => api(commit).addOfferGroup({ templateId, offerId }),
      setLoadingFunction: isLoading =>
        commit(SET_IS_ADDING_OFFER_GROUP, isLoading)
    });
    dispatch(FETCH_CURRENT_OFFER_GROUPS, offerId);
  },
  async [REMOVE_OFFER_GROUP]({ dispatch, commit }, { offerId, groupId }) {
    await handleWithErrorMessage({
      dispatch,
      request: () => api(commit).removeOfferGroup(groupId)
    });
    dispatch(FETCH_CURRENT_OFFER, offerId);
  },
  async [EDIT_OFFER_GROUP]({ dispatch, commit }, { groupId, data }) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).editOfferGroup({ groupId, data })
    });
  }
};

export default actions;
